export default {
    'error.default': 'CANT_PROCESS',
    'error.payment': 'DEPOSIT.ERRORS.DURING_PAYMENT',
    'error.creditcard.declined': 'DEPOSIT.ERRORS.CREDIT_CARD_DECLINED',
    'error.invalid.postalCode': 'DEPOSIT.ERRORS.INVALID_POSTAL_CODE',
    'error.vehicle.alreadyLocked': 'DEPOSIT.ERRORS.VEHICLE_ALREADY_LOCKED',
    'error.group.address': 'DEPOSIT.ERRORS.ADDRESS_GROUP',
    'error.group.deposit': 'DEPOSIT.ERRORS.DEPOSIT_GROUP',
    'error.group.identity': 'DEPOSIT.ERRORS.IDENTITY_GROUP',
    invalid_cvc: 'DEPOSIT.ERRORS.INVALID_CVC',
    incorrect_cvc: 'DEPOSIT.ERRORS.INCORRECT_CVC',
    incorrect_number: 'DEPOSIT.ERRORS.INCORRECT_NUMBER',
    invalid_number: 'DEPOSIT.ERRORS.INVALID_NUMBER',
    invalid_expiry_month: 'DEPOSIT.ERRORS.INVALID_EXPIRY_MONTH',
    invalid_expiry_year: 'DEPOSIT.ERRORS.INVALID_EXPIRY_YEAR',
};



// WEBPACK FOOTER //
// ./src/constants/errors.js